import type {
  SanityPageBuilderEditorialCardsSection,
  SanityPageBuilderLegacyEditorialCardsArticleCardSection,
  SanityPageBuilderSection,
} from "@ouster/shared";

/**
 * The pre-page-builder migration could leave a card child as a top-level
 * section. A card cannot render without the document it references; omitting
 * that empty remnant is preferable to exposing the generic developer scaffold
 * to site visitors. A populated legacy article card is handled by the
 * compatibility adapter below.
 */
export function isEmptyLegacyEditorialCardSection(section: SanityPageBuilderSection) {
  const content = section.sectionContent;

  if (section._type !== "editorialCardsArticleCard.field" || content?._type !== "editorialCardsArticleCard") {
    return false;
  }

  return !content.article;
}

/** Converts a valid legacy root card into the supported one-card section view. */
export function toEditorialCardsSection(
  card: SanityPageBuilderLegacyEditorialCardsArticleCardSection
): SanityPageBuilderEditorialCardsSection | undefined {
  if (!card.article) {
    return undefined;
  }

  return {
    _type: "ouster.pageBuilder.section.editorialCards",
    cards: [card],
  };
}
